"use client";

import { JDIProductCardV2 } from "@/lib/jdiClientUtils";
import { useStores } from "@/models";
import { sendClickTrack, EXPOSURE_RECORD, IExpoTrackParamsRecord } from "@/tracks/25157";
import { sendClickTrack as sendClickTrack25348, EXPOSURE_RECORD as EXPOSURE_RECORD25348 } from "@/tracks/25348";
import { sendClickTrack as sendClickTrack25282, EXPOSURE_RECORD as EXPOSURE_RECORD25282 } from "@/tracks/25282";
import { getPromotionObj } from "@/app/s/util";
import styles from "./index.module.scss";

export const ProductList = ({ paragraphsForRender, searchParams, logid, basePath, isAddon }: any) => {
  const { searchForAddonStore } = useStores();

  const { k, l1, l2, l3 } = searchParams;
  const frontCategoryId = l3 || l2 || l1 || "";

  return (
    <div className={styles.productList}>
      {paragraphsForRender.map((p: any, index: number) => {
        const extParams = getPromotionObj(p?.content?.promotions);
        const promotionTrackParams = {
          batchId: searchForAddonStore.batchId || "-100",
          foreLabel: "-100",
          labelWords: "-100",
        };
        const commonTracks = {
          keyWord: k || "-100",
          categoryId: frontCategoryId || "-100",
          logid: logid,
          pvid: logid,
          request_id: logid,
          mtest: "-100",
          channelName: "Search_result",
          skuid: p.skuId,
          pos: index,
          firprice: p.content?.realPrice,
          firpricetype: "11" as "11",
          secprice: p.content?.originalPrice,
          secpricetype: "83" as "83",
          freqTag: "-100",
          ...extParams,
          ...(basePath == "/s-for-addon" ? promotionTrackParams : {}),
        };
        return (
          <JDIProductCardV2
            key={`${p.skuId}_${p.type}`}
            productData={{
              type: "2",
              width: 240,
              // height: 478,
              containerStyle: { marginBottom: "12px" },
              skuName: p.content.wareName,
              skuNameStyle: {},
              skuId: p.skuId,
              skuImgKeyParams: {
                imgUrlKey: p.content.imageUrl,
                width: 240,
                height: 240,
              },
              cdnDomains: process.env.NEXT_PUBLIC_IMAGE_CDN_DOMAIN?.split(","),
              realPrice: p.content?.realPrice,
              originalPrice: p.content?.originalPrice,
              currency: "£",
              score: p.content.commentScore,
              saleNum: p.content.saleNum,
              promotions: p.content.promotions,
              shouldShowScore: true,
              shouldShowCart: true,
              isOutOfStock: p.wareInStock === "0",
              shouldShowMoreModel: true,
              moreModels: p.slaveWareVOS,
              onAddCartSuccess: () => {
                searchForAddonStore.getPromoInfos();
              },
              titleRightDom: p.isHot && (
                <span
                  style={{
                    fontSize: "12px",
                    color: "#FF9FA7",
                    backgroundColor: "#FFF3F4",
                    padding: "5px",
                    alignSelf: "flex-start",
                    borderTopLeftRadius: "3px",
                    borderBottomLeftRadius: "3px",
                  }}
                >
                  HOT
                </span>
              ),
              trackingPointParams: {
                productExpConfig: {
                  event_id:
                    basePath === "/s-for-addon"
                      ? isAddon
                        ? EXPOSURE_RECORD25282.FreeShippingAddOn_MergeMain_Product_Expo
                        : EXPOSURE_RECORD25348.Promotion_MergeMain_Product_Expo
                      : EXPOSURE_RECORD.Search_ProductList_Product_Expo,
                  config: { useClick: false, stay_duration: 0, repeated: false, area_rate: 0.5 },
                  json_param: commonTracks as IExpoTrackParamsRecord["Search_ProductList_Product_Expo"],
                },
                productClickPoint: () => {
                  basePath === "/s-for-addon"
                    ? isAddon
                      ? sendClickTrack25282.FreeShippingAddOn_MergeMain_Product(commonTracks as any)
                      : sendClickTrack25348.Promotion_MergeMain_Product(commonTracks as any)
                    : sendClickTrack.Search_ProductList_Product(commonTracks);
                },
                cartClickPoint: () => {
                  basePath === "/s-for-addon"
                    ? isAddon
                      ? sendClickTrack25282.FreeShippingAddOn_MergeMain_Product_AddtoCart(commonTracks as any)
                      : sendClickTrack25348.Promotion_MergeMain_Product_AddtoCart(commonTracks as any)
                    : sendClickTrack.Search_ProductList_Product_AddtoCart(commonTracks);
                  basePath === "/s-for-addon" &&
                    !isAddon &&
                    sendClickTrack25348.Promotion_Cart({
                      skuid: commonTracks.skuid,
                      firprice: commonTracks.firprice,
                      firpricetype: commonTracks.firpricetype,
                      secprice: commonTracks.secprice,
                      secpricetype: commonTracks.secpricetype,
                      index,
                    });
                },
              },
            }}
          />
        );
      })}
      {/* 用于最后一行，当剩余商品不足一排时，占位，否则会导致最后一排排布不正确 */}
      <i aria-hidden="true" style={{ width: 240 }}></i>
      <i aria-hidden="true" style={{ width: 240 }}></i>
      <i aria-hidden="true" style={{ width: 240 }}></i>
    </div>
  );
};
